import { Permissions, type IPermissions } from './permissions'

export enum UserState {
  New = 'new',
  Registered = 'registered'
}

export interface IUserDetailsDto {
  name: string
  email: string
  company: string
  companyAddress?: string
  companyBusinessId?: string
  phoneNumber?: string
  state?: UserState
  safetyVideoValid?: boolean
  needsFcmTokenUpdate: boolean
  permissions?: IPermissions

  isNewUser(): boolean
  toPostBody(): Record<string, any>
}

export class UserDetailsDto implements IUserDetailsDto {
  name: string
  email: string
  company: string
  companyAddress?: string
  companyBusinessId?: string
  phoneNumber?: string
  state?: UserState
  safetyVideoValid?: boolean
  needsFcmTokenUpdate: boolean = true
  permissions?: IPermissions

  constructor(
    name: string,
    email: string,
    company: string,
    companyAddress?: string,
    companyBusinessId?: string
  ) {
    this.name = name
    this.email = email
    this.company = company
    this.companyAddress = companyAddress
    this.companyBusinessId = companyBusinessId
  }
  toJSON(): object {
    const result: any = {}

    result.name = this.name
    result.email = this.email
    result.company = this.company

    if (this.companyAddress != null) result.companyAddress = this.companyAddress
    if (this.companyBusinessId != null) result.companyBusinessId = this.companyBusinessId
    if (this.phoneNumber != null) result.phoneNumber = this.phoneNumber
    if (this.state != null) result.state = this.state
    if (this.safetyVideoValid != null) result.safetyVideoValid = this.safetyVideoValid
    result.needsFcmTokenUpdate = this.needsFcmTokenUpdate
    if (this.permissions != null) result.permissions = this.permissions

    return result
  }
  static fromJson(json: any): UserDetailsDto {
    // Required
    const name = json.name as string
    const email = json.email as string
    const company = json.company as string

    const userDetails = new UserDetailsDto(name, email, company)

    if (json.companyAddress != null) userDetails.companyAddress = json.companyAddress
    if (json.companyBusinessId != null) userDetails.companyBusinessId = json.companyBusinessId
    if (json.phoneNumber != null) userDetails.phoneNumber = json.phoneNumber
    if (json.state != null) userDetails.state = json.state
    if (json.safetyVideoValid != null) userDetails.safetyVideoValid = json.safetyVideoValid
    if (json.permissions != null) userDetails.permissions = json.permissions

    if (json.needsFcmTokenUpdate != null) {
      userDetails.needsFcmTokenUpdate = json.needsFcmTokenUpdate
    }

    return userDetails
  }
  isNewUser(): boolean {
    return this.state === UserState.New
  }

  toPostBody(): Record<string, any> {
    return {
      name: this.name,
      email: this.email,
      company: this.company,
      companyAddress: this.companyAddress ?? '',
      companyBusinessId: this.companyBusinessId ?? ''
    }
  }

  static createValidUserData(): UserDetailsDto {
    const userDetailsDto = new UserDetailsDto(
      'Testaaja ',
      'test@test.com',
      'Yritys Oy',
      'Testaustie 4',
      '1234567-1'
    )
    userDetailsDto.state = UserState.Registered
    userDetailsDto.safetyVideoValid = true
    userDetailsDto.needsFcmTokenUpdate = false

    const permissions = new Permissions(false, false, false, true, true, false)
    userDetailsDto.permissions = permissions
    return userDetailsDto
  }
}
